import { useEffect, useState } from "react";

import { CommandPalette } from "@/components/CommandPalette";
import { OfflineBanner } from "@/components/pwa/OfflineBanner";
import { PWAUpdater } from "@/components/pwa/PWAUpdater";
import { ShortcutsDialog } from "@/components/ShortcutsDialog";

/** Window event other components can dispatch to open the command palette (e.g. mobile button). */
export const OPEN_COMMAND_EVENT = "catalogkit:open-command";

/** Hosts the command palette + shortcuts dialog and wires global keyboard shortcuts. */
export function AppChrome(): JSX.Element {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [shortcutsOpen, setShortcutsOpen] = useState(false);

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent): void {
      const target = event.target as HTMLElement | null;
      const inField =
        target != null &&
        (target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.tagName === "SELECT" ||
          target.isContentEditable);

      if ((event.key === "k" || event.key === "K") && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        setPaletteOpen((open) => !open);
        return;
      }
      if (inField) return;
      if (event.key === "/") {
        event.preventDefault();
        const search = document.getElementById("catalogkit-search");
        if (search) search.focus();
        else setPaletteOpen(true);
        return;
      }
      if (event.key === "?") {
        event.preventDefault();
        setShortcutsOpen(true);
      }
    }

    function onOpenCommand(): void {
      setPaletteOpen(true);
    }

    window.addEventListener("keydown", onKeyDown);
    window.addEventListener(OPEN_COMMAND_EVENT, onOpenCommand);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener(OPEN_COMMAND_EVENT, onOpenCommand);
    };
  }, []);

  return (
    <>
      <CommandPalette
        open={paletteOpen}
        onOpenChange={setPaletteOpen}
        onShowShortcuts={() => setShortcutsOpen(true)}
      />
      <ShortcutsDialog open={shortcutsOpen} onOpenChange={setShortcutsOpen} />
      <OfflineBanner />
      <PWAUpdater />
    </>
  );
}
